$(document).ready(() => {
    TRNMNT_helpers.comment('#gameCommentForm', GAME_COMMENT);
    TRNMNT_helpers.like('.comment-like svg use', GAME_COMMENT);
    TRNMNT_deleteData({
        selector: '.comment-delete',
        url: GAME_COMMENT,
        success: function (response, $button) {
            $button.closest('.template-comment').remove();
        }
    });
});
